import { useField } from "formik";
import * as m from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../../reducers/app";
import { uploadFileToS3 } from "../../../../reducers/auth";
import Modal from "../../../common/Modal/Modal";
import "./UploadField.scss";
import { TranslatedText } from "../../../../helpers/helpers";

export default function UploadField(props) {
  const { errorText, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { setValue } = helper;

  const fileUpload = useRef(null);

  const [uploadStatus, setUploadStatus] = useState("init");
  const [uploadMessage, setUploadMessage] = useState(
    t("cases.request_info.fields.file.drag")
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalErrorOpen, setModalErrorOpen] = useState(false);

  const InfoLabel = ({ label }) => {
    return (
      <div className="info-label info-label-upload">
        <span className="gc-icon-functional-attention-2-col">
          <span className="path1" />
          <span className="path2" />
        </span>
        <p>{label}</p>
      </div>
    );
  };
  const handleSelect = () => {
    // setUploadStatus('open')
    fileUpload.current.click();
  };

  const dragEnter = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setUploadMessage(t("cases.request_info.fields.file.release"));
    setUploadStatus("enter");
  };
  const dragOver = (e) => {
    e.preventDefault();
    setUploadStatus("over");
  };
  const dragLeave = (e) => {
    e.preventDefault();
    setUploadStatus("init");
    setUploadMessage(t("cases.request_info.fields.file.drag"));
  };
  const fileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      handleFile(file);
    }
  };
  const btnSubmit = document.querySelector(".action-buttons .btn-primary");
  useEffect(() => {
    setValue("");
    return () => {
      if (btnSubmit) {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
      }
    };
  }, []);

  useEffect(() => {
    if (selectedFile) {
      dispatch(showLoading());
      setUploadMessage(t("cases.request_info.fields.file.uploading"));
      setUploadStatus("upload");
      const extension = selectedFile?.type?.split("/")[1];

      const timestamp = m().unix();
      const fileNameUpload = `analisi-acqua-${timestamp}.${extension}`;
      uploadFileToS3("analisi/" + fileNameUpload, selectedFile)
        .then((response) => {
          dispatch(hideLoading());
          setValue(fileNameUpload);
          setUploadMessage(t("cases.request_info.fields.file.uploaded"));
          setUploadStatus("uploaded");
          setErrorMessage("");
          btnSubmit.disabled = false;
          btnSubmit.classList.remove("disabled");
        })
        .catch((error) => {
          dispatch(hideLoading());
          setUploadStatus("has-error");
          setUploadMessage("");
          setErrorMessage("");
          setModalErrorOpen(true);
          console.log("error: ", error);
          setValue("");
          btnSubmit.disabled = true;
          btnSubmit.classList.add("disabled");
        });
    }
  }, [selectedFile]); // eslint-disable-line react-hooks/exhaustive-deps
  const handleFile = (file) => {
    if (validateFile(file)) {
      setSelectedFile(file);
    } else {
      setUploadMessage("");
      setUploadStatus("has-error");
      setErrorMessage(t("cases.request_info.errors.file.not_supported"));
      setValue("");
      btnSubmit.disabled = true;
      btnSubmit.classList.add("disabled");
    }
  };
  const validateFile = (file) => {
    const validTypes = rest.allowedExtensions;
    if (validTypes.indexOf(file.type) === -1 || file.size / 1024 / 1024 > 10) {
      return false;
    }
    return true;
  };
  const onChange = (e) => {
    e.preventDefault();
    setUploadStatus("select");
    let file = e.target.files[0];
    handleFile(file);
    field.onChange(e);
  };
  useEffect(() => {
    if (
      meta.touched &&
      meta.error &&
      uploadStatus !== "upload" &&
      uploadStatus !== "enter"
    ) {
      setUploadStatus("has-error");
      setErrorMessage(meta.error);
    }
  }, [meta.touched, meta.error, uploadStatus]);
  return (
    <div className="UploadField">
      <Form.Group controlId="formBasicUpload">
        <div
          className={uploadStatus ? `dropBox ${uploadStatus}` : "dropBox"}
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          onDrop={fileDrop}
        >
          <i
            className={
              errorMessage || uploadStatus === "has-error"
                ? "gc-icon-functional-close-circle-2-col"
                : uploadStatus === "uploaded"
                ? "gc-icon-functional-check-2-col"
                : "gc-icon-functional-doc-2-col"
            }
          >
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
          {["init", "open", "over"].includes(uploadStatus) && (
            <p className="drop-file">{uploadMessage}</p>
          )}
          {uploadStatus === "upload" && (
            <p className="uploading">{uploadMessage}</p>
          )}
          {uploadStatus === "uploaded" && (
            <p className="success">{uploadMessage}</p>
          )}

          {uploadStatus === "uploaded" && (
            <p className="upload-new">
              {t("cases.request_info.fields.file.upload_new")}
            </p>
          )}
          <div className="pb-5">
            {errorMessage && <p className="invalid-feedback">{errorMessage}</p>}
            {uploadStatus === "has-error" && (
              <p className="invalid-feedback drag-file">
                {" " + t("cases.request_info.fields.file.drag")}
              </p>
            )}
          </div>

          {uploadStatus !== "upload" && (
            <Button
              id="mobile-upload-button"
              onClick={handleSelect}
              variant="secondary"
            >
              {uploadStatus !== "uploaded" && !errorMessage
                ? t("cases.buttons.upload_file")
                : t("cases.buttons.reupload_file")}
            </Button>
          )}
        </div>
        <div
          className={
            uploadStatus === "over" ? "fileSelect hidden" : "fileSelect"
          }
        >
          <Form.Label>{rest.label}</Form.Label>
          <Fragment>
            <input
              type="file"
              name={field.name}
              onChange={onChange}
              as="upload"
              accept={[...rest.allowedExtensions]}
              className={meta.touched && meta.error ? "is-invalid" : "nothing"}
              ref={fileUpload}
              style={{ display: "none" }}
            />
            <Button
              id="upload-button"
              onClick={handleSelect}
              variant="secondary"
            >
              {t("cases.buttons.select_file")}
            </Button>
            <InfoLabel
              label={
                <TranslatedText i18nKey="complex.case.file.upload.allowed" />
              }
            />
          </Fragment>
        </div>
        <Modal
          show={modalErrorOpen}
          onClose={() => setModalErrorOpen(false)}
          noIcon={true}
          ariaLabelled={true}
          titleClass={"text-center"}
          description={t("cases.request_info.fields.file.error")}
          isWithForm={false}
          type={"button"}
          linkTitle={t("common.hoCapito")}
          onFirstClick={() => setModalErrorOpen(false)}
        ></Modal>
      </Form.Group>
    </div>
  );
}
